export default __webpack_public_path__ + "static/feature-2-b42cdf4a099ad97744664b8698628f77.png";